// @ts-nocheck
import { Session } from "@insite/client-framework/Services/SessionService";
import constants from "@store/constants";

const hasRoleWithAllowances = (userRoles: string) => {
    const rolesWithAllowances = [constants.userRole.buyer2];

    return userRoles
        .split(",")
        .map(r => r.trim())
        .some(role => rolesWithAllowances.includes(role));
};

const hasCustomerCarryOverUnusedMonthlyBalances = (session?: Session) =>
    session &&
    session.properties &&
    "carryOverUnusedMonthlyBalances" in session.properties &&
    session.properties.carryOverUnusedMonthlyBalances.toLowerCase() === "true";

export { hasCustomerCarryOverUnusedMonthlyBalances, hasRoleWithAllowances };
